export const getErrorMessageBarStyles = () => ({
  errorMessageBar: {
    maxWidth: 552,
  },
});
